export class DistributorManufacturer {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    businessName: string;
    phone: string;
    countryCode: string;
    title: string;
    picturePath: string;
    registrationDate: string;
    type: string;
    status: number;
    numberOfSubscriptions: string;
    numberOfSponsors: string;
    promotionCodeCount: number;
    constructor(distributorData: any) {
      this.id = distributorData.id;
      this.firstName = distributorData.firstName;
      this.lastName = distributorData.lastName;
      this.email = distributorData.email;
      this.businessName = distributorData.businessName;
      this.phone = distributorData.phone;
      this.countryCode = distributorData.countryCode;
      this.title = distributorData.title;
      this.picturePath = distributorData.picturePath;
      this.registrationDate = distributorData.registrationDate;
      this.type = distributorData.type;
      this.status = distributorData.status;
      this.numberOfSubscriptions = distributorData.numberOfSubscriptions;
      this.numberOfSponsors = distributorData.numberOfSponsors;
      this.promotionCodeCount = distributorData.promotionCodeCount;
    }
  }
